import axios from 'axios';
import { loginreq, req } from './axiosFun';

// 定义通用api前缀
//其知网后台接口url前缀(本地)
// var webRoot = 'http://192.168.101.7/index.php';
//其知网后台后台接口url前缀(线上)
// var webRoot = 'https://zlbb.qzhip.com/index.php';
// var webRoot = 'http://zlbb.qzhip.test/index.php';

// 登录接口 
export const login = (params) => { return loginreq("post", "/patent/login/adminLogin", params) };
// 获取用户菜单
export const menu = (params) => { return req("post", "/patent/Admin/userMenuList", params) };
// 退出接口
export const loginout = () => { return axios.delete("/api/login?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

/**
 * 首页
 */
// 首页统计数据
export const indexCensus = () => { return req("post","/admin/User/indexCensus") };

/**
 * 用户管理 
 **/
// 用户管理-获取用户列表
export const userList = (params) => { return req("post", "/patent/Admin/userList", params) };
// 用户管理-保存（添加编辑）
export const userSave = (params) => { return req("post", "/patent/Admin/editUser", params) };
// 用户管理-删除用户
export const userDelete = (params) => { return req("post", "/patent/Admin/delUser", params) };
// 用户管理-重置密码
export const userPwd = (params) => { return req("post", "/patent/Admin/resetPwd", params) };
// 用户管理-获取角色列表
export const getRoleList = (params) => { return req("post", "/patent/role/getRoleList", params) };
// 用户管理-修改状态
export const userLock = (params) => { return axios.get("/api/User/lock?userId=" + params.userId + "&lock=" + params.lock + "&token=" + localStorage.getItem('logintoken')) };
// 用户管理-数据权限
export const UserDeptTree = (params) => { return axios.get("/api/UserDept/tree/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 用户管理-数据权限保存
export const UserDeptSave = (params) => { return req("post", "/api/UserDept/save", params) };
// 用户管理-获取部门设置
export const UserDeptdeptTree = (params) => { return axios.get("/api/UserDept/deptTree/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 用户管理-保存部门设置
export const UserChangeDept = (params) => { return req("post", "/api/User/change/dept", params) };
// 用户管理-用户下线
export const userExpireToken = (params) => { return req("get", "/api/User/expireToken/" + params, {}) };
// 用户管理-刷新缓存
export const userFlashCache = (params) => { return req("get", "/api/User/flashCache/" + params, {}) };

// 用户管理-查询账户检索值
export const getUserSearch = (params) => { return req("post", "/patent/admin/getSearchValue", params) };
// 用户管理-删除检索值(单个)
export const delSearchValue = (params) => { return req("post", "/patent/admin/delSearchValue", params) };
// 用户管理-删除检索值(勾选)
export const delCheckSearchValue = (params) => { return req("post", "/patent/admin/delCheckSearchValue", params) };
// 用户管理-添加检索值
export const addSearchValue = (params) => { return req("post", "/patent/admin/addSearchValue", params) };
// 用户管理-导入检索值
export const importSearchValue = (params) => { return req("post", "/patent/admin/importSearchValue", params) };
// 用户管理-查询导入检索值excel
export const downloadSearchExcel = (params) => { return req("post", "/patent/admin/downloadSearchExcel", params) };

/**
 * 菜单管理
 **/
// 菜单管理-获取菜单Module/list
export const ModuleList = () => { return req("post", "/patent/permission/permissionListAll") };
// 菜单管理-根据菜单获取数据
export const ModuleGet = (params) => { return axios.get("/api/Module/get/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 菜单管理-获取父级菜单Module/nodes
export const ModuleNodes = (params) => { return req("post", "/patent/permission/permissionList", params) };
// 菜单管理-修改菜单
export const ModuleSave = (params) => { return req("post", "/patent/permission/editPermission", params) };
// 菜单管理-删除菜单
export const ModuleDelete = (params) => { return req("post", "/patent/permission/delPermission", params) };

/**
 * 角色管理 
 **/
// 角色管理-获取角色列表
export const roleList = (params) => { return req("post", "/patent/role/roleList", params) };

// 角色管理-保存（添加编辑）
export const roleSave = (params) => { return req("post", "/patent/role/editRole", params) };
// 角色管理-删除角色
export const roleDelete = (params) => { return req("post", "/patent/role/delRole", params) };
// 角色管理-菜单权限（获取）
export const RoleRightTree = (params) => { return req("post", "/patent/role/rolePermissionList", params) };
// export const RoleRightTree = (params) => { return axios.get("/api/RoleRight/tree/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 角色管理-菜单权限（保存）
export const RoleRightSave = (params) => { return req("post", "/api/RoleRight/save", params) };
// 角色管理-编辑-角色已有权限
export const roleInfo = (params) => { return req("post", "/patent/role/roleInfo", params) };

/**
 * 公司管理 
 **/
// 公司管理-获取公司列表
export const deptList = (params) => { return req("post", "/api/Dept/list", params) };
// 公司管理-保存（添加编辑）
export const deptSave = (params) => { return req("post", "/api/Dept/save", params) };
// 公司管理-删除公司
export const deptDelete = (params) => { return axios.get("/api/Dept/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

/**
 * 系统环境变量 
 **/
// 系统环境变量-获取系统环境变量列表
export const variableList = (params) => { return req("post", "/admin/system/systemConfigList", params) };
// 系统环境变量-保存（添加编辑）
export const variableSave = (params) => { return req("post", "/admin/system/editSystemConfig", params) };
// 系统环境变量-删除系统环境变量
export const variableDelete = (params) => { return req("post", "/admin/system/delSystemConfig", params) };

/**
 * 权限管理 
 **/
// 权限管理-获取权限列表
export const permissionList = (params) => { return req("post", "/api/Permission/list", params) };
// 权限管理-保存权限
export const ermissionSave = (params) => { return req("post", "/api/Permission/save", params) };
// 权限管理-删除权限
export const ermissionDelete = (params) => { return axios.delete("/api/Permission/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 权限管理-获取权限
export const roleDropDown = () => { return axios.get("/api/Role/dropDown/all?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 权限管理-配置权限
export const RolePermission = (params) => { return req("post", "/api/RolePermission/save", params) };

// 首页
// 首页-个人中心
export const userInfo = (params) => { return req("post", "/admin/user/getUserInfo", params) };
// 首页-个人中心-编辑信息
export const editUserInfo = (params) => { return req("post", "/admin/user/editUserInfo", params) };
// 首页-个人中心-修改密码
export const resetUserPwd = (params) => { return req("post", "/admin/user/resetUserPwd", params) };

// 首页-个人中心-访问量查询
export const getVisitCensus = (params) => { return req("post", "/admin/user/getVisitCensus", params) };

// 首页-个人中心-访问量查询(v2版)
export const getVisitCensusV2 = (params) => { return req("post", "/admin/user/getVisitCensusV2", params) };

// 首页-个人中心-访问量表格下载
export const downloadVisitExcel = (params) => { return req("post", "/admin/user/downloadCensusExcel", params) };
// 系统管理-专利管理列表
export const getUserPatentList = (params) => { return req("post", "/patent/monitor/getUserPatentList", params) };
// 系统管理-专利管理-会员列表(下拉框)
export const getSelectUserList = (params) => { return req("post", "/patent/monitor/getSelectUserList", params) };
// 系统管理-专利管理-编辑技术领域(单个)
export const editPatentTechnology = (params) => { return req("post", "/patent/monitor/editPatentTechnology", params) };
// 系统管理-专利管理-编辑技术领域(勾选)
export const editCheckPatentTechnology = (params) => { return req("post", "/patent/monitor/editCheckPatentTechnology", params) };
// 系统管理-专利管理-查询技术领域
export const getTechnologyList = (params) => { return req("post", "/patent/monitor/getTechnologyList", params) };



export const webUrl = 'https://zlbb.qzhip.com/index.php';
// export const webUrl = 'http://zlbb.qzhip.test/index.php';


// WEBPACK FOOTER //
// ./src/api/userMG.js